var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.needsOnboarding)?_c('CContainer',[_c('OnboardingSteps',{on:{"action":_vm.runAction}}),_c('OnboardingActions',{ref:"actions"})],1):_c('div',[_c('CContainer',[_c('HomeOrders')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }